<template>
  <div
    :class="{ downloadable }"
    class="chat-attachment px-3 py-2 bg-light border rounded-lg"
    @click="download"
  >
    <i class="font-xl mr-2 icon-doc" />
    <i class="font-xl mr-2 icon-cloud-download" />
    <div>
      <div>{{ filename }}</div>
      <div class="small">
        <template v-if="progress < 1">
          upload {{ Math.ceil(100 * progress) }}%
        </template>
        <template v-else>{{ size | bytes }}</template>
      </div>
    </div>

    <button
      v-if="!hideRemove"
      v-b-tooltip.hover="xTitle"
      class="remove-btn"
      @click="$emit('remove')"
    >
      &times;
    </button>
  </div>
</template>

<script>
import API from "@/api";
import { downloadFile } from "@/helpers/download";

export default {
  props: {
    id: Number,
    filename: String,
    size: Number,
    downloadable: Boolean,
    hideRemove: Boolean,
    progress: {
      type: Number,
      default: 1
    },
    xTitle: {
      type: String,
      default: "remove"
    }
  },

  methods: {
    async download() {
      if (!this.downloadable) return;
      const r = await API.getChatAttachmentUrl(this.id);
      if (!r.success) {
        return this.$notify({
          type: "error",
          text: r.error.message
        });
      }

      downloadFile(this.filename, r.results);
    }
  }
};
</script>

<style lang="scss">
.chat-attachment {
  position: relative;
  display: flex;
  align-items: center;
  word-break: break-word;

  &:hover .remove-btn {
    display: block;
  }

  &.downloadable {
    cursor: pointer;

    &:hover .icon-doc {
      display: none;
    }

    &:hover .icon-cloud-download {
      display: inline-block;
    }
  }

  .icon-cloud-download {
    display: none;
  }

  .remove-btn {
    display: none;
    position: absolute;
    top: -0.5rem;
    right: -0.5rem;
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1rem;
    border-radius: 50%;
    border: none;
    border: 1px solid var(--gray-200);
    color: var(--white);
    // background: var(--gray-600);
    background: rgba(0, 0, 0, 0.5);

    &:hover,
    &:focus {
      font-weight: bold;
      // background: var(--gray-800);
      background: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
